export default __webpack_public_path__ + "static/integrations_security-66454c47755601ca5d60c7ca198033c7.png";